import request from '@/util/http'
//获取教职工花名册列表
export function getStaffPage (params) {
    return request({
      url: '/hq/facultyAndStaff/page',
      method: 'get',
      params
    })
  }

//工资查询
export function getMangeList (params) {
    return request({
      url: '/hq/pay/page',
      method: 'get',
      params
    })
  }

//年度考核评选结果查询列表
export function yearCheckList (params) {
  return request({
    url: '/hq/yearCheck/page',
    method: 'get',
    params
  })
}

//岗位聘用查询
export function postEmploy (params) {
  return request({
    url: '/hq/postEmploy/page',
    method: 'get',
    params
  })
}

// 年度考核评选Excel下载模板
export const downloadTemp=()=>{
   return `/hq/yearCheck/downloadTemp`;
  }

  // 岗位聘用查询Excel下载模板
export const jobDowlod=()=>{
  return `/hq/postEmploy/downloadTemp`;
 }
  
// 岗位聘级别获取
export const parentList=()=>{
  return request({
    url: '/hq/postInfo/parentList',
    method: 'get',
  })
 }


 // 岗位聘等级
export const childList=(id)=>{
  return request({
    url: `/hq/postInfo/childList?parentId=${id}`,
    method: 'get',
  })
 }

//  获取学期信息
export const semesterList=()=>{
  return request({
    url: `/hq/semester/list`,
    method: 'get',
  })
 }


//  根据年级id查班级
export const classList=(params)=>{
  return request({
    url: `/hq/administrationClass/getClassList`,
    method: 'get',
    params
  })
 }

 //年级list
export const gradeList=(params)=>{
  return request({
    url: `/hq/administrationClass/getGradeNameList`,
    method: 'get',
    params
  })
 }

  //学生成绩统计
export const finalGrade=(params)=>{
  return request({
    url: `/hq/finalGrade/page`,
    method: 'get',
    params
  })
 }

 // Excel导出
export const excelExport=(params)=>{
  let str = ''
  for(let key in params){
    str += `&${key}=${params[key]}`
  }  
  return `/hq/finalGrade/exportGradeUser?${str}`;
}


  //专业科下拉框
  export const getOrgNameList=(params)=>{
    return request({
      url: `/hq/administrationClass/getOrgNameList`,
      method: 'get',
      params
    })
   }

    //专业下拉框
  export const getSpecialtyNameList=(id)=>{
    return request({
      url: `/hq/administrationClass/getSpecialtyNameList/${id}`,
      method: 'get',
    })
   }
